<cv-generic-export [items]="items" [fileName]="fileName"></cv-generic-export>
<div class="chart-container">
  <canvas #canvas baseChart *ngIf="chartConfig" [type]="chartConfig.type" [legend]="chartConfig.options.plugins?.legend"
    [datasets]="chartConfig.data.datasets" [labels]="chartConfig.data.labels" [options]="chartConfig.options"
    [plugins]="chartConfig.plugins">
  </canvas>
</div>